import React, { useState, useRef, useEffect } from "react";
import { Col, Navbar, Button, Dropdown, InputGroup, FormControl } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header, { HeaderNav, Menu, MobileMenu, SearchBar } from '../../Components/Header/HeaderBus';
import { IMAGE_PATHS, DOMAIN_URL } from '../../Functions/Constant';
import API from '../../Api/Api';
import SearchHeaderForMobBus from '../Header/SearchHeaderForMobBus';
import HeaderData from "../../Components/Header/HeaderDataBus"; // Import HeaderData

const tooltipStyles = `
  .tooltip-container {
    position: relative;
    display: inline-block;
  }
    

  .tooltip-box {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 15px;
    width: 300px;
    z-index: 1000;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    text-align: center;
  }

  .tooltip-container:hover .tooltip-box {
    visibility: visible;
    opacity: 1;
  }

  .tooltip-box h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .tooltip-box p {
    font-size: 14px;
    color: #333;
    margin-bottom: 15px;
  }

  .tooltip-box button {
    background-color: #000;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  }

  .tooltip-box button:hover {
    background-color: #333;
  }
    `;

const MyHeader = (props) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [userData, setUserData] = useState(null);
    const [jwtTokenJobcritic, setjwtTokenJobcritic] = useState(localStorage.getItem("jwt_token_jobcritic"));
    const [searchQuery, setSearchQuery] = useState(''); // Added state for search query
    const navigate = useNavigate();
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("Name");
    const location = useLocation();
    const [showTooltip, setShowTooltip] = useState(false);
    const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
    const dropdownRef = useRef(null);
    const fetchDataUser = async () => {
        try {
            const endpoint = `/user`;
            const res = await API.get(endpoint);
            if (res.user) {
                const userData = {
                    name: res.user.name || "Unknown User",
                    profile_image: res.user.profile_image ? DOMAIN_URL + res.user.profile_image : IMAGE_PATHS.USER,
                    email: res.user.email || "Unknown User",
                    credit_balance: res.user.credit_balance || 0,
                };

                setUserData(userData);
                localStorage.setItem("userData", JSON.stringify(userData));
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    };
    // New function to handle search
    const handleSearch = () => {
        if (searchQuery.trim()) {
            let categoryValue = selectedCategory.toLowerCase();
            if (selectedCategory === "School/College") {
                categoryValue = "school";
            }
            navigate(`/search-employee?query=${encodeURIComponent(searchQuery)}&category=${encodeURIComponent(categoryValue)}`);
            setSearchQuery('');
        }
    };

    // Handle Enter key press
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    useEffect(() => {
        // document.querySelector("body").classList.remove("overflow-hidden");
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
            try {
                setUserData(JSON.parse(storedUserData));
            } catch (error) {
                console.error("Error parsing userData:", error);
                fetchDataUser();
            }
        } else {
            fetchDataUser();
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close dropdown if click is outside dropdownRef
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        const handleScroll = () => {
            setIsScrolled(window.scrollY > 27);
            if (location.pathname === "/verifications") {
                // setShowSearchBar(window.scrollY >= 245);
                const screenWidth = window.innerWidth;
                const scrollThreshold = screenWidth >= 991 ? 245 : 180;

                setShowSearchBar(window.scrollY >= scrollThreshold);
            }
            setShowDropdown(false); // Close dropdown on scroll
        };

        // Add mousedown listener to the document
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll);
        };
    }, [location.pathname]);


    if (jobcritic_usertype == 2) {

    } else {
        navigate("/");
    }


    // Handle logout
    const handleLogout = () => {
        localStorage.clear();
        localStorage.removeItem("userData");
        setjwtTokenJobcritic(null);
        setUserData(null);
        setTimeout(() => {
            window.location.assign("/");
        }, 100);
    };

    const menuData = HeaderData(jwtTokenJobcritic) || [];

    const isDisabled = location.pathname === '/business-form';
    const renderUserDropdown = () => (
        <Dropdown className="ml-[1.3rem]">
            <Dropdown.Toggle as="div" className="cursor-pointer">
                <img
                crossorigin="anonymous"
                    src={userData?.profile_image || IMAGE_PATHS.USER}
                    alt="User"
                    className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
                />
            </Dropdown.Toggle>

            <Dropdown.Menu className="bg-white shadow-lg rounded-lg py-2 w-[270px] xs:!left-[-159px] xs:!w-[240px] md:!left-[-200px] !left-[-228px]">
                {/* Profile Info */}
                <div className="flex items-center space-x-3 px-4 py-3 border-b">
                    {isDisabled ? (
                        <span className="text-gray-500 cursor-not-allowed opacity-50">
                            <img
                            crossorigin="anonymous"
                                src={userData?.profile_image || IMAGE_PATHS.USER}
                                alt="User"
                                className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
                            />
                        </span>
                    ) : (
                        <Link to="/verifications">
                            <img
                            crossorigin="anonymous"
                                src={userData?.profile_image || IMAGE_PATHS.USER}
                                alt="User"
                                className="w-[40px] h-[40px] rounded-full object-cover border border-gray-300"
                            />
                        </Link>
                    )}
                    <div>
                        {isDisabled ? (
                            <>
                                <span className="text-gray-500 cursor-not-allowed opacity-50">
                                    <p className="text-gray-900 font-semibold text-sm">{userData?.name || 'User Name'}</p>
                                </span>
                                <p className="text-gray-500 text-xs">{userData?.email || ''}</p>
                            </>
                        ) : (
                            <>
                                <Link to="/verifications">
                                    <p className="text-gray-900 font-semibold text-sm">{userData?.name || 'User Name'}</p>
                                </Link>
                                <Link to="/verifications">
                                    <p className="text-gray-500 text-xs">{userData?.email || ''}</p>
                                </Link>
                            </>
                        )}

                    </div>
                </div>

                {/* Options */}
                {isDisabled ? (
                    <span className="block px-4 py-2 text-gray-500 cursor-not-allowed opacity-50">
                        Account Settings
                    </span>
                ) : (
                    <Dropdown.Item
                        as={Link}
                        to="/account-settings"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                        Account Settings
                    </Dropdown.Item>
                )}
                <div className="border-t my-2"></div>
                {isDisabled ? (
                    <span className="block px-4 py-2 text-gray-500 cursor-not-allowed opacity-50">
                        Business settings
                    </span>
                ) : (
                    <Dropdown.Item
                        as={Link}
                        to="/business-settings"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                        Business settings
                    </Dropdown.Item>
                )}
                <div className="border-t my-2"></div>
                {isDisabled ? (
                    <span className="block px-4 py-2 text-gray-500 cursor-not-allowed opacity-50">
                        Support
                    </span>
                ) : (
                    <Dropdown.Item
                        as={Link}
                        to="/contact_us"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                        Support
                    </Dropdown.Item>
                )}
                <div className="border-t my-2"></div>
                <Dropdown.Item
                    onClick={handleLogout}
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                >
                    Logout
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
    return (
        <>
            <Header topSpace={{ md: true }} type="responsive-sticky">
                <HeaderNav theme="light" bg="white" expand="lg" className={`py-[0px] px-[35px] lg:px-[15px] md:px-[15px] md:py-[15px] sm:px-0 ${isScrolled ? "shadow-md" : ""}`}>

                    {/* Logo */}
                    <Col lg={1} sm={3} xs={"auto"} className="mr-auto ps-0 fdd">
                        <Link aria-label="header logo" className="flex items-center" to="/">
                            <Navbar.Brand className="inline-block p-0 m-0">
                                <img crossorigin="anonymous" className="default-logo" width="111" height="60" src={IMAGE_PATHS.LOGO} alt="logo" />
                                <img crossorigin="anonymous" className="alt-logo" width="111" height="60" src={IMAGE_PATHS.LOGO} alt="logo" />
                            </Navbar.Brand>
                        </Link>
                    </Col>
                    {jwtTokenJobcritic && (location.pathname !== '/verifications' || showSearchBar) && (
                        <Col lg={5} xs="auto" className={`justify-end pe-0 flex items-center sdff ${isDisabled ? 'p-[13px]' : ''
                            }`}>
                            {/* Search Input */}
                            <div className="w-[100%] flex rounded-full shadowla1 bg-white relative overflow-visible leading-[1.7] md:hidden">
                                {/* Search */}
                                <div className="flex-1 relative">
                                    <input
                                        type="text"
                                        placeholder="Search To Review"
                                        value={searchQuery}
                                        onChange={(e) => !isDisabled && setSearchQuery(e.target.value)}
                                        onKeyDown={isDisabled ? undefined : handleKeyPress}
                                        className={`w-full pl-[3.5rem] pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-full custom-placeholder ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
                                            }`}
                                        disabled={isDisabled}
                                    />
                                    <div className="absolute inset-y-0 left-[1.5rem] flex items-center pointer-events-none">
                                        <svg
                                            viewBox="0 0 24 24"
                                            width="20px"
                                            height="20px"
                                            className="text-gray-400"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"
                                            />
                                        </svg>
                                    </div>
                                </div>

                                {/* Dropdown */}
                                <hr className="h-[24px] border border-[#caccd4] relative top-[7px]" />
                                <div
                                    className={`relative flex items-center justify-between px-4 py-2 rounded-r-full w-[35%] md:w-[43%] xs:w-[32%] ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
                                        }`}
                                    onClick={(e) => {
                                        if (!isDisabled) {
                                            e.stopPropagation(); // Prevent click from bubbling to document
                                            setShowDropdown(!showDropdown);
                                        }
                                    }}
                                    ref={dropdownRef}
                                >
                                    <span className="text-[13px] font-medium text-[#757575]">{selectedCategory}</span>
                                    <svg
                                        className="w-4 h-4 ml-2 text-gray-500"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>

                                    {showDropdown && (
                                        <ul className="absolute top-full right-0 mt-2 w-60 bg-white border border-gray-200 shadow-xl rounded-xl text-sm z-[9999] py-2">
                                            {['Name', 'Contact', 'Company', 'School/College', 'Location'].map((item) => (
                                                <li
                                                    key={item}
                                                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${item === selectedCategory ? 'font-semibold text-gray-600' : ''
                                                        }`}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent click from bubbling to document
                                                        setSelectedCategory(item);
                                                        setShowDropdown(false);
                                                    }}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <SearchBar className="xs:pl-[15px] order-last d-lg-none" isDisabled={isDisabled}/>
                        </Col>
                    )}

                    {/* Navbar Toggle */}
                    <Navbar.Toggle className="order-last md:ml-[17px] md:px-[15px] sm:px-0">
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                        <span className="navbar-toggler-line"></span>
                    </Navbar.Toggle>


                    <Navbar.Collapse className="justify-end col-auto col-lg-4 sm:z-[4]" >
                        {!isDisabled && (<> <Menu className="md:hidden" data={menuData} {...props} /></>)}
                        <MobileMenu
                            className="order-last d-lg-none"
                            type="modern"
                            data={menuData}
                            userData={jwtTokenJobcritic ? userData : null} // Pass userData directly
                            onLogout={jwtTokenJobcritic ? handleLogout : null} // Pass handleLogout directly
                            {...props}
                            isDisabled={isDisabled}
                        />
                    </Navbar.Collapse>
                    <Col lg={"auto"} sm={"auto"} xs={"auto"} className="mr-auto pe-0 xs:m-0 md:mr-0">
                        {!isDisabled && (<>
                            <div className="tooltip-container">
                                <div className="wha">
                                    <i className="fas fa-wallet text-[18px] text-black pt-[8px] cursor-pointer"
                                        onMouseEnter={() => setShowTooltip(true)}
                                        onMouseLeave={() => setShowTooltip(false)} ></i>
                                    <span className=" text-bold text-black relative left-[9px] bottom-[1px]">{userData?.credit_balance} {userData?.credit_balance === 1 ? 'Credit' : 'Credits'}</span>
                                </div>

                            </div>
                        </>)}
                    </Col>

                    <Col lg={1} xs={"auto"} className="justify-end pe-0 flex items-center">
                        {jwtTokenJobcritic ? (

                            <div className="d-none d-lg-block" userData={userData}>{renderUserDropdown()}</div>

                        ) : (
                            <></>
                        )}
                    </Col>


                </HeaderNav>
                {/* {jwtTokenJobcritic && (location.pathname !== '/verifications' || showSearchBar) && (
                    <HeaderNav theme="light" expand="lg" className="py-[0px] px-[35px] lg:px-[15px] md:px-[15px] md:py-[15px] sm:px-0 f_none !pt-[2px]">
                        <SearchHeaderForMobBus />
                    </HeaderNav>
                )} */}
            </Header>

            {showTooltip && (
                <div className="fixed top-20 left-[61%] transform -translate-x-1/2 bg-white border border-gray-300 shadow-lg rounded-xl p-6 w-[auto] z-[9999] text-center">
                    <h4 className="text-lg font-bold mb-2 text-black">{userData?.credit_balance == 10 ? 'Awesome!' : (userData?.credit_balance > 0 ? 'Remaining Credits' : 'Credits Exhausted')}</h4>
                    <p className="text-sm text-gray-600 mb-4">{
                        userData?.credit_balance == 10 ? 'You’ve unlocked 10 free credits to explore candidate profiles. One credit provides access to one profile verification.' : (userData?.credit_balance > 0 ? 'You have ' + (userData?.credit_balance) + ' credits remaining. Each credit allows you to verify one candidate profile. Use them wisely!' : 'You’ve used all your 10 credits! . To continue using the service, please contact us for assistance.')}</p>

                </div>
            )}
        </>

    );
};

export default MyHeader;
